import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AiOutlineSnippets } from 'react-icons/ai'
import { BsFacebook, BsCodeSlash, BsLink45Deg } from 'react-icons/bs'
import { BiStore } from 'react-icons/bi'
import SideMenu from '../layouts/SideMenu'
import MenuWrap from '../components/BurgerMenu/MenuWrap'
import { isMobile } from '../components/DeviceDetection'
import Modal from '../layouts/Modal'

const FirstTrackerMain = () => {
  const navigate = useNavigate()

  const handleNav = async (activePage) => {
    const pageType = 'firstTracker'
    navigate('/new-tracker', { state: { activePage, pageType } })
  }
  const [isModalOpen, setIsModalOpen] = useState(isMobile())

  return (
    <>
      <div
        id="outer-container"
        style={{ height: '100%', backgroundColor: '#FAFAFA' }}
      >
        <MenuWrap className="sm:hidden">
          <SideMenu isAuthorized={true}></SideMenu>
        </MenuWrap>
        <div id="page-wrap">
          <div className="flex">
            <SideMenu
              isAuthorized={true}
              className="hidden sm:block"
            ></SideMenu>
            <div className="w-full md:pt-0 pt-32">
              <div
                className="flex flex-col justify-center items-center h-[calc(100vh-74px)] px-10"
                aria-live="polite"
              >
                {/* Header */}
                <div className="text-center mb-20">
                  <h1 className="text-2xl font-unbounded text-gray-900">
                    Let's create your  <strong>M-Link.</strong>
                  </h1>
                </div>

                {/* Cards Container */}
                <div className="grid grid-cols-1 gap-[8rem] lg:grid-cols-4 max-w-7xl mx-auto mb-20 items-baseline">
                  {/* Card 1 - Snippet */}
                  <div
                    id="snippet"
                    className="flex flex-col items-center cursor-pointer"
                    onClick={() => handleNav('snippet')}
                  >
                    <div className="w-64 h-64 rounded-2xl flex flex-row items-start pt-12 gap-4 justify-center p-6 bg-metrinome-shadow-green border border-metrinome-border-green">
                      {/* Icon container */}
                      <div className="w-[100px] h-[50px] border border-metrinome-border-green rounded-lg flex items-center justify-center mb-4">
                        <AiOutlineSnippets className="h-6 w-6 text-gray-800" />
                      </div>

                      {/* Text content */}
                      <div className="text-left">
                        <h3 className="text-sm font-medium text-gray-800 mb-1 font-unbounded">
                          Get the
                        </h3>
                        <h2 className="text-l font-bold text-gray-900 mb-4 font-unbounded">
                          SNIPPET
                        </h2>
                        <p className="text-sm text-gray-800">
                          Add a code to your website
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 - Postback */}
                  <div
                    id="postbackJS"
                    className="flex flex-col items-center cursor-pointer hidden"
                    onClick={() => handleNav('postbackJS')}
                  >
                    <div className="w-64 h-64 rounded-2xl flex flex-row items-start pt-12 gap-4 justify-center p-6 bg-metrinome-shadow-green border border-metrinome-border-green">
                      <div className="w-[100px] h-[50px] border border-metrinome-border-green rounded-lg flex items-center justify-center mb-4">
                        <BsCodeSlash className="h-6 w-6 text-gray-800" />
                      </div>

                      <div className="text-left">
                        <h3 className="text-sm font-medium text-gray-800 mb-1 font-unbounded">
                          Place the
                        </h3>
                        <h2 className="text-l font-bold text-gray-900 mb-4 font-unbounded">
                          POSTBACK CODE
                        </h2>
                        <p className="text-sm text-gray-800">
                          Add a code to your website&apos;s thank you page
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 - Source */}
                  <div
                    id="source"
                    className="flex flex-col items-center cursor-pointer"
                    onClick={() => handleNav('source')}
                  >
                    <div className="w-64 h-64 rounded-2xl flex flex-row items-start pt-12 gap-4 justify-center p-6 bg-metrinome-shadow-green border border-metrinome-border-green">
                      {/* Icon container */}
                      <div className="w-[100px] h-[50px] border border-[#DFF3C5] rounded-lg flex items-center justify-center mb-4">
                        <BsFacebook className="h-6 w-6 text-gray-800" />
                      </div>

                      {/* Text content */}
                      <div className="text-left">
                        <h3 className="text-sm font-medium text-gray-800 mb-1 font-unbounded">
                          Add a
                        </h3>
                        <h2 className="text-l font-bold text-gray-900 mb-4 font-unbounded">
                          SOURCE
                        </h2>
                        <p className="text-sm text-gray-800">
                          Select Campaign Platform
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Card 4 - Campaign Details */}
                  <div
                    id="campaignDetails"
                    className="flex flex-col items-center cursor-pointer"
                    onClick={() => handleNav('campaignDetails')}
                  >
                    <div className="w-64 h-64 rounded-2xl flex flex-row items-start pt-12 gap-4 justify-center p-6 bg-metrinome-shadow-green border border-metrinome-border-green">
                      {/* Icon container */}
                      <div className="w-[100px] h-[50px] border border-[#DFF3C5] rounded-lg flex items-center justify-center mb-4">
                        <BiStore className="h-6 w-6 text-gray-800" />
                      </div>

                      {/* Text content */}
                      <div className="text-left">
                        <h3 className="text-sm font-medium text-gray-800 mb-1 font-unbounded">
                          Add Campaign
                        </h3>
                        <h2 className="text-l font-bold text-gray-900 mb-4 font-unbounded">
                          DETAILS
                        </h2>
                        <p className="text-sm text-gray-800">
                          Name your campaigns and targeting details
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Card 5 - Final URL */}
                  <div
                    id="campaignDestination"
                    className="flex flex-col items-center cursor-pointer"
                    onClick={() => handleNav('campaignDestination')}
                  >
                    <div className="w-64 h-64 rounded-2xl flex flex-row items-start pt-12 gap-4 justify-center p-6 bg-metrinome-shadow-green border border-metrinome-border-green">
                      {/* Icon container */}
                      <div className="w-[100px] h-[50px] border border-[#DFF3C5] rounded-lg flex items-center justify-center mb-4">
                        <BsLink45Deg className="h-6 w-6 text-gray-800" />
                      </div>

                      {/* Text content */}
                      <div className="text-left">
                        <h3 className="text-sm font-medium text-gray-800 mb-1 font-unbounded">
                          Add a
                        </h3>
                        <h2 className="text-l font-bold text-gray-900 mb-4 font-unbounded">
                          FINAL URL
                        </h2>
                        <p className="text-sm text-gray-800">
                          Add final URL that you are tracking as KPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="w-full max-w-6xl mx-auto">
                  <div className="relative">
                    <div
                      className="absolute top-1/2 transform -translate-y-1/2 w-full h-1"
                      style={{ backgroundColor: '#FAD170' }}
                    ></div>
                    <div className="relative flex justify-between">
                      <div
                        className="w-8 h-8 rounded-full"
                        style={{ backgroundColor: '#FAD170' }}
                      ></div>
                      <div
                        className="w-8 h-8 rounded-full"
                        style={{ backgroundColor: '#F5F5DC' }}
                      ></div>
                      <div
                        className="w-8 h-8 rounded-full"
                        style={{ backgroundColor: '#F5F5DC' }}
                      ></div>
                      <div
                        className="w-8 h-8 rounded-full"
                        style={{ backgroundColor: '#F5F5DC' }}
                      ></div>
                      <div
                        className="w-8 h-8 rounded-full"
                        style={{ backgroundColor: '#F5F5DC' }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <Modal setIsModalOpen={setIsModalOpen} backGroundClass={'darkBG'}>
          <div className="modalContent mx-auto bg-onTrack-light-pink rounded p-3">
            <p className={`text-red-600 ${isModalOpen}`}>
              This application should be accessed on a desktop for optimal
              functionality and user experience, as it is not intended for
              mobile use.
            </p>
          </div>
        </Modal>
      )}
    </>
  )
}

export default FirstTrackerMain
